export default {
  "students.billing.isento": "Tuition Exempt",
  "students.billing.isento_with_count": "Tuition Exempt ({{count}})",
  "students.billing.generate": "Generate Installments",
  "students.billing.installments_one": "1 Installment Generated",
  "students.billing.installments_many": "{{count}} Installments Generated"
};